import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

// INITIAL STATE
export interface AppState {
  showDevData: boolean;
}

const initialState: AppState = {
  showDevData: false,
};

// REDUCERS
export const devSlice = createSlice({
  name: 'dev',
  initialState,
  reducers: {
    toggleDevData: (state, action: PayloadAction<any>) => {
      state.showDevData = !state.showDevData;
    },
  },
});

// ACTIONS
export const { toggleDevData } = devSlice.actions;

// SELECTORS
export const shouldShowDevData = createSelector(
  (state: RootState) => state.dev.showDevData,
  (flag) => flag
);

export default devSlice.reducer;
